export const timelogKeys = {
  all:            ['timelogs'] as const,
  byAccessRole:   (id: number, from: string, to: string) =>
    ['timelogs', 'list', id, from, to] as const,
  employeeLookup: (accessRoleId: number, value: string) =>
    ['employees', 'lookup', accessRoleId, value] as const,
};
